import IPFSImage from "./IPFSImage";

type CardProps = {
  description: string;
  image: string;
  className?: string;
  variants?: 'primary' | 'secondary';
} & React.ComponentPropsWithoutRef<'button'>;

const Card: React.FC<CardProps> = ({ image, description, className = '', variants = 'primary', ...rest }) => {
    return (
        <article className="overflow-hidden rounded-lg shadow-lg">
            <div>
                <IPFSImage src={image} />
            </div>

            <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                <h1 className="text-lg">
                    <div className="no-underline text-black">
                        {description}
                    </div>
                </h1>
            </header>
        </article>
    );
};

export default Card;
